module.exports = __webpack_public_path__ + "static/img/img-011.752486e.jpg";